<template lang="pug">
section.visualizar-territorio
    .dados
        header
            h1
                i.el-icon-arrow-left.back(@click='goToTerritorio()')
                | {{ $t('mensagens.territorio.labels.territorio') }}
        .mb2(v-if='territorio')
            p
                b {{ $t('mensagens.territorio.labels.nome') }}:
                |
                | {{ territorio.nome }}
            p
                b {{ $t('mensagens.territorio.labels.areaHa') }}:
                |
                | {{ formatNumber(territorio.areaHa) }}
            p
                b {{ $t('mensagens.territorio.labels.localidade') }}:
                |
                | {{ territorio.localidade }}
            p(v-if='nomesCertificacoes')
                b {{ $t('mensagens.territorio.labels.certificacoes') }}:
                |
                | {{ nomesCertificacoes }}
            p
                b {{ $t('mensagens.territorio.labels.dataDeCadastro') }}:
                |
                | {{ territorio.dataCadastroFormatada || territorio.dataCadastro }}
            p(v-if='territorio.dataAtualizacao')
                b {{ $t('mensagens.territorio.labels.dataDaUltimaAtualizacao') }}:
                |
                | {{ territorio.dataAtualizacaoFormatada }}
            p(v-if='permissaoAmbiente(ambientes.PARAGUAY)')
                b {{ $t('mensagens.territorio.labels.padron') }}:
                |
                | {{ isValidValue(territorio.padron) ? territorio.padron : '-' }}

            p(v-if='permissaoAmbiente(ambientes.PARAGUAY)')
                b {{ $t('mensagens.territorio.labels.finca') }}:
                |
                | {{ isValidValue(territorio.finca) ? territorio.finca : '-' }}

            p(v-if='permissaoAmbiente(ambientes.PARAGUAY) || permissaoAmbiente(ambientes.ARGENTINA)')
                b {{ $t('mensagens.territorio.labels.codigoLyra') }}:
                |
                | {{ territorio.codigoLyra || '-' }}
            p(v-if='permissaoAmbiente(ambientes.ARGENTINA)')
                b {{ $t('mensagens.territorio.labels.idInterno') }}:
                |
                | {{ territorio.idInterno || '-' }}

        hr

        el-collapse(
            v-model='collapseDadosTerritorioAtivo',
            @change='handleChangeCollapse',
            accordion
        )
            el-collapse-item(name='REPRESENTANTE')
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-user-second
                        |
                        | {{ $t('mensagens.territorio.labels.pessoas') }}
                .container-dados-collapse
                    div(v-if='representantes.length')
                        .representante.mb2(
                            v-for='representante in representantes'
                        )
                            p
                                b {{ $t('mensagens.territorio.labels.nome') }}:
                                |
                                | {{ representante.nomeRazaoSocial }}

                            p
                                b {{ $t('mensagens.territorio.labels.documento') }}:
                                |
                                | {{ numeralStringFormatTocpfCnpj(representante.cpfCnpj) }}

                            p(v-if='representante.email')
                                b {{ $t('mensagens.territorio.labels.email') }}:
                                |
                                | {{ representante.email }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

            el-collapse-item(
                name='CAR',
                v-if='permissaoAmbiente(ambientes.BRASIL)'
            )
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-shape
                        |
                        | {{ $t('mensagens.territorio.labels.cars') }}
                .container-dados-collapse
                    div(v-if='cars.length > 0')
                        el-table#tabelas-collapse(
                            :data='cars',
                            style='width: 100%'
                        )
                            el-table-column
                                template(slot='header', slot-scope='scope')
                                    span {{ $t('mensagens.territorio.labels.codigo') }}
                                template(slot-scope='scope')
                                    span {{ scope.row.codigo }}
                            el-table-column(width='90')
                                template(slot='header', slot-scope='scope')
                                    span {{ $t('mensagens.territorio.labels.condicao') }}
                                template(slot-scope='scope')
                                    span {{ scope.row.condicao }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )
            el-collapse-item(
                name='INFORMACAO',
                v-if='permissaoAmbiente(ambientes.PARAGUAY)'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-briefcase-arrow-up-down-outline
                        |
                        | {{ $t('mensagens.territorio.information.titulo') }}
                .container-dados-collapse
                    div(v-if='territorio?.informacaoAgricolaPY?.length > 0')
                        el-table#tabelas-collapse(
                            :data='territorio.informacaoAgricolaPY',
                            style='width: 100%'
                        )
                            el-table-column(
                                prop='nome',
                                :label='$t("mensagens.territorio.information.cultivo")'
                            )
                            el-table-column(
                                prop='areaPlantada',
                                :label='$t("mensagens.territorio.information.area")'
                            )
            el-collapse-item(
                name='ARQUIVOS',
                v-if='!permissaoAmbiente(ambientes.BRASIL)'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-file-download-outline
                        |
                        | {{ $t('mensagens.territorio.arquivo.arquivo') }}
                .container-dados-collapse
                    .arquivo-lista(
                        v-if='territorio?.arquivosTerritorio?.length > 0'
                    )
                        .arquivo-item(
                            v-for='arquivo in territorio.arquivosTerritorio',
                            :key='arquivo.id'
                        )
                            .arquivo-info
                                .header-info
                                    i.mdi.mdi-file-outline.arquivo-icon
                                    strong {{ $t('mensagens.territorio.arquivo.nome') }}
                                span.arquivo-information {{ arquivo.nomeArquivo }}
                            .grid-colums-cards
                                .arquivo-info
                                    .header-info
                                        i.mdi.mdi-information-outline.arquivo-icon
                                        strong {{ $t('mensagens.territorio.labels.tipo') }}
                                    span.arquivo-information {{ arquivo.arquivoProdutor ? $t('mensagens.territorio.arquivo.produtor') : $t('mensagens.territorio.arquivo.empresa') }}
                                .arquivo-info
                                    .header-info
                                        i.mdi.mdi-clock-time-four-outline.arquivo-icon
                                        strong {{ $t('mensagens.territorio.arquivo.dataUpload') }}
                                    span.arquivo-information {{ arquivo.dataUpload }}

                                .arquivo-info-acao
                                    el-button.download-btn(
                                        type='primary',
                                        size='mini',
                                        icon='el-icon-download',
                                        @click='downloadArquivo(arquivo)',
                                        :loading='downloadingFiles[arquivo.id]'
                                    )

                            hr.divisor-arquivo
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

            el-collapse-item(
                name='CERTIFICACOES',
                v-if='permissaoAmbiente(ambientes.ARGENTINA)'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-certificate-outline
                        |
                        | {{ $t('mensagens.territorio.certificacao.archivosSacs') }}
                .container-dados-collapse
                    div(v-if='territorio.evidenciasCertificacao?.length > 0')
                        .certificacao-lista
                            .certificacao-item(
                                v-for='(certificacao, index) in territorio.evidenciasCertificacao',
                                :key='index'
                            )
                                .certificacao-nome
                                    .header-info(:class='{ "sem-evidencia": certificacao.evidencias.length === 0 }')
                                        i.mdi.mdi-check-decagram.arquivo-icon
                                        strong {{ certificacao.tipo }}
                                    .certificacao-info(v-if='certificacao.evidencias.length > 0')
                                        i.mdi.mdi-file-document-multiple-outline.certificacao-icon
                                        span.certificacao-nome-texto
                                            | {{ certificacao.evidencias.length }} {{ certificacao.evidencias.length === 1 ? $t('mensagens.territorio.certificacao.evidenciasSingular') : $t('mensagens.territorio.certificacao.evidenciasPlural') }}
                                    .certificacao-info.sem-evidencia(v-else)
                                        i.mdi.mdi-alert-circle-outline.certificacao-icon
                                        span.certificacao-nome-texto
                                            | {{ $t('mensagens.territorio.certificacao.nenhumaEvidencia') }}
                                
                                .evidencia-item(
                                    v-for='evidencia in certificacao.evidencias',
                                    :key='evidencia.id'
                                )
                                    .arquivo-info
                                        .header-info
                                            i.mdi.mdi-file-outline.arquivo-icon
                                            strong {{ $t('mensagens.territorio.certificacao.nomeDoArquivo') }}
                                        span.arquivo-information {{ evidencia.descripcion }}
                                    .grid-colums-cards
                                        .arquivo-info
                                            .header-info
                                                i.mdi.mdi-calendar-outline.arquivo-icon
                                                strong {{ $t('mensagens.territorio.certificacao.campanha') }}
                                            span.arquivo-information {{ evidencia.campania }}
                                        .arquivo-info
                                            .header-info
                                                i.mdi.mdi-clock-time-four-outline.arquivo-icon
                                                strong {{ $t('mensagens.territorio.certificacao.data') }}
                                            span.arquivo-information {{ evidencia.ultimaModificacionFecha }}

                                        .arquivo-info-acao
                                            el-button.download-btn(
                                                type='primary',
                                                size='mini',
                                                icon='el-icon-download',
                                                @click='downloadEvidencia(evidencia.id)',
                                                :loading='downloadingFiles[evidencia.id]'
                                            )

                                    hr.divisor-arquivo(v-if='certificacao.evidencias.indexOf(evidencia) < certificacao.evidencias.length - 1')
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

            el-collapse-item(
                name='DECLARACAO_JURADA',
                v-if='usuarioLogado.isArgentinaRevenda && territorio.evidenciasDeclaracaoJurada?.length > 0'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-file-document-edit-outline
                        |
                        | {{ $t('mensagens.territorio.certificacao.titulo') }}
                .container-dados-collapse
                    .arquivo-lista.evidencia-declaracao-jurada-lista
                        .arquivo-item.evidencia-declaracao-jurada-item(
                            v-for='evidencia in territorio.evidenciasDeclaracaoJurada',
                            :key='evidencia.id'
                        )
                            .evidencia-dj-row-1
                                .arquivo-info
                                    .header-info
                                        i.mdi.mdi-file-outline.arquivo-icon
                                        strong {{ $t('mensagens.territorio.declaracaoJurada.nomeDoArquivo') }}
                                    span.arquivo-information {{ evidencia.nomeArquivo }}
                                .arquivo-info-acao
                                    el-button.download-btn(
                                        type='primary',
                                        size='mini',
                                        icon='el-icon-download',
                                        @click='downloadArquivo(evidencia)',
                                        :loading='downloadingFiles[evidencia.id]'
                                    )
                            .evidencia-dj-row-2
                                .arquivo-info
                                    .header-info
                                        i.mdi.mdi-tag-outline.arquivo-icon
                                        strong {{ $t('mensagens.territorio.declaracaoJurada.tipoSoja') }}
                                    span.arquivo-information {{ evidencia.tipoSoja }}
                                .arquivo-info
                                    .header-info
                                        i.mdi.mdi-clock-time-four-outline.arquivo-icon
                                        strong {{ $t('mensagens.territorio.declaracaoJurada.dataUpload') }}
                                    span.arquivo-information {{ evidencia.dataUpload }}

                            hr.divisor-arquivo(v-if='territorio.evidenciasDeclaracaoJurada.indexOf(evidencia) < territorio.evidenciasDeclaracaoJurada.length - 1')

            el-collapse-item(
                v-if='usuarioLogado.historicoMonitoramentoAccess',
                name='HISTORICO_AGRICOLA'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-history
                        |
                        | {{ $t('mensagens.territorio.historicoAgricola') }}

                .container-dados-collapse
                    div(v-if='historicos.length')
                        el-table#tabelas-collapse(
                            @cell-mouse-enter='tabelaHistoricoAgricolaHover',
                            @cell-mouse-leave='tabelaHistoricoAgricolaLeaver',
                            :data='historicos',
                            style='width: 100%'
                        )
                            el-table-column(
                                :label='$t("mensagens.territorio.labels.ciclo")'
                            )
                                template(slot-scope='scope')
                                    span {{ scope.row.codigoAnoSafra }}
                            el-table-column(
                                prop='codigoCultura',
                                :label='$t("mensagens.territorio.labels.cultura")'
                            )
                            el-table-column(width='110')
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.labels.produtividade') }}
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.produtividadeKgHa }}
                            el-table-column(width='110')
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.labels.areaPlantada') }}
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.areaHa }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

            el-collapse-item(
                v-if='!territorio?.internacional && !permissaoAmbiente(ambientes.PARAGUAY)',
                name='DIAGNOSTICO_SOCIOAMBIENTAL'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-clipboard-pulse-outline
                        |
                        | {{ $t('mensagens.territorio.labels.diagnosticoAmbiental') }}

                .container-dados-collapse
                    div(v-if='diagnosticoSocioambientalTerritorio')
                        DiagnosticoSocioambiental(
                            v-if='refMapa',
                            :dadosConsulta='diagnosticoSocioambientalTerritorio',
                            @index-aberto='mostrarRestricaoTerritorio',
                            :mapaLeaflet='refMapa',
                            :habilitar-zoom-restricao='true'
                        )
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

    mapa.mapa(
        :mapLayersConfigs='layersMaps',
        :mapConfig='mapConfig',
        :height='"100%"',
        :idMapa='"mapaTerritorio"',
        ref='mapa',
        :atualizarMapa='true',
        :menuMaior='true'
    )
</template>

<script>
import territorioService from '@/services/TerritorioService';
import Mapa from '@/components/MapaLeaflet.vue';
import formatters from '@/utils/formatters';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapState } from 'vuex';
import HistoricoService from '@/services/HistoricoService';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import CulturaService from '@/services/CulturaService';

export default {
    name: 'VisualizarTerritorio',
    components: {
        Mapa,
        DiagnosticoSocioambiental
    },
    data() {
        return {
            idTerritorio: this.$route.params.idTerritorio,
            territorio: null,
            representantes: [],
            cars: [],
            comercializacoes: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true
                }
            },
            historicos: [],
            collapseDadosTerritorioAtivo: '',
            tabelaHistoricoRowSelecionada: null,
            nomesCertificacoes: '',
            diagnosticoSocioambientalTerritorio: null,
            refMapa: null,
            ambientes: AmbientesEmpresas,
            downloadingFiles: {} // Para controlar o estado de loading dos downloads
        };
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    watch: {
        '$i18n.locale': {
            handler() {
                this.traducaoValores();
            }
        }
    },
    mounted() {
        this.fetchTerritorio();
        this.refMapa = this.$refs.mapa;
    },
    methods: {
        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        async fetchTerritorio() {
            const isArgentina = this.usuarioLogado.ambienteLogado === 'AR';
            
            const { data } = isArgentina
                ? await territorioService.findByIdAR(this.idTerritorio)
                : await territorioService.findById(this.idTerritorio);
                
            this.territorio = data;
            this.cars = this.territorio.cars || [];
            this.representantes = this.territorio.representantes || [];

            if (isArgentina) {
                this.formatarLocalidadeArgentina();
            }
            
            this.setupComercializacoes(isArgentina);
            this.setupCertificacoes();
            this.getCultura();
            this.configureLayersMapa();
        },

        formatarLocalidadeArgentina() {
            const { localidades } = this.territorio;
    
            if (!localidades?.length) {
                return;
            }

            const provincia = localidades.find(loc => loc.nivel === 1);
            const municipio = localidades.find(loc => loc.nivel === 3);

            this.territorio.localidade = this.construirNomeLocalidade(municipio, provincia);
        },

        construirNomeLocalidade(municipio, provincia) {
            if (municipio?.nome && provincia?.sigla) {
                return `${municipio.nome} - ${provincia.sigla}`;
            }
            
            return municipio?.nome || provincia?.nome || '';
        },

        setupComercializacoes(isArgentina) {
            if (isArgentina) {
                this.comercializacoes = this.territorio.informacaoAgricolaPY || [];
                return;
            }

            if (!this.territorio.comercializacoes) {
                this.comercializacoes = [];
                return;
            }

            this.comercializacoes = this.territorio.comercializacoes.map(c => ({
                ...c,
                quantidade: formatters.formatNumber(c.quantidade),
                info: ` - ${formatters.formatNumber(c.quantidade)} (${c.unidadeMedida.simbolo})`
            }));
        },

        setupCertificacoes() {
            if (!this.territorio.evidenciasCertificacao?.length) {
                this.nomesCertificacoes = '';
                return;
            }

            this.nomesCertificacoes = this.territorio.evidenciasCertificacao
                .map(cert => cert.tipo)
                .filter(tipo => tipo !== 'OUTROS')
                .join(', ');
        },
        traducaoValores() {
            const valorTraduzido = this.$t(
                'mensagens.territorio.comercializacao'
            );

            this.comercializacoes = this.territorio.comercializacoes.map(c => {
                const produtoLowerCase = c.produto.codigo
                    .toLowerCase()
                    .replace(/_./g, match => match.charAt(1).toUpperCase());
                const unidadeMedidaLowerCase = c.unidadeMedida.codigo
                    .toLowerCase()
                    .replace(/_./g, match => match.charAt(1).toUpperCase());

                const nomeProdutoTraduzido =
                    valorTraduzido[produtoLowerCase] || c.produto.nome;
                const unidadeMedidaTraduzido =
                    valorTraduzido[unidadeMedidaLowerCase] ||
                    c.unidadeMedida.nome;

                return {
                    ...c,
                    produto: {
                        ...c.produto,
                        nome: nomeProdutoTraduzido
                    },
                    unidadeMedida: {
                        ...c.unidadeMedida,
                        nome: unidadeMedidaTraduzido
                    },
                    quantidade: formatters.formatNumber(c.quantidade),
                    info: ` - ${formatters.formatNumber(c.quantidade)} (${
                        c.unidadeMedida.simbolo
                    })`
                };
            });
        },
        configureLayersMapa() {
            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território',
                geoJson: this.territorio.geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        numeralStringFormatTocpfCnpj(valor) {
            return formatters.numeralStringFormatTocpfCnpj(
                valor,
                this.usuarioLogado.ambienteLogado
            );
        },
        formatNumber(number) {
            return number
                ? Number(number).toLocaleString('pt-br', {
                      minimumFractionDigits: 4
                  })
                : '-';
        },
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return (
                parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
            );
        },
        isValidValue(value) {
            return (
                value !== null &&
                value !== undefined &&
                value !== 'null' &&
                value !== ''
            );
        },

        goToTerritorio() {
            const { ambienteLogado } = this.usuarioLogado;
            const isSucursal = !!this.$route.query.sucursal;

            const routeMap = {
                AR: isSucursal ? 'TerritorioSucursales' : 'TerritorioArgentina',
                default: 'Territorio'
            };

            const targetRoute = routeMap[ambienteLogado] || routeMap.default;
            this.$router.push({ name: targetRoute });
        },
        async downloadArquivo(arquivo) {
            try {
                this.$set(this.downloadingFiles, arquivo.id, true);

                const link = document.createElement('a');
                link.href = arquivo.urlDownload;
                link.download = arquivo.nomeArquivo;
                link.target = '_blank';

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$notify.success({
                    type: 'success',
                    message: this.$t('mensagens.certificado.sucessDownload')
                });
            } catch (error) {
                this.$notify.error({
                    type: 'error',
                    message: this.$t('mensagens.certificado.erroDownload')
                });
            } finally {
                this.$set(this.downloadingFiles, arquivo.id, false);
            }
        },
        async downloadEvidencia(evidenciaId) {
            await territorioService.downloadEvidenciaArgentina(evidenciaId)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.operacao.notificacao.downloadRealizado'
                        )
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.operacao.notificacao.downloadErro'
                        )
                    })
                );
        },
        async handleChangeCollapse() {
            switch (this.collapseDadosTerritorioAtivo) {
                case 'HISTORICO_AGRICOLA':
                    await this.buscarHistoricoAgricola();
                    break;

                case 'DIAGNOSTICO_SOCIOAMBIENTAL':
                    await this.buscarDiagnosticoSocioambiental();
                    break;
                default:
                    break;
            }
        },
        async buscarHistoricoAgricola() {
            const { data } = await HistoricoService.buscarAgricola(
                JSON.stringify(this.territorio.geometria)
            );
            this.historicos = data;
        },

        async buscarDiagnosticoSocioambiental() {
            const { data } = await DiagnosticoSocioambientalService.buscarPorId(
                JSON.stringify(this.territorio.diagnosticoSocioambiental.id)
            );
            this.diagnosticoSocioambientalTerritorio = {
                diagnostico: JSON.parse(data.resultado)
            };
        },

        mostrarRestricaoTerritorio(_, __, indexCamada) {
            this.layersMaps = [];

            this.layersMaps.push({
                style: getEstiloGeometria('area'),
                name: 'Território',
                geoJson: this.territorio.geometria
            });

            if (indexCamada) {
                this.diagnosticoSocioambientalTerritorio.diagnostico[
                    indexCamada
                ].resultados.forEach((restricao, index) => {
                    this.layersMaps.push({
                        style: getEstiloGeometria('restricao'),
                        name: `restricaoTerritorio_${indexCamada}_${index}`,
                        geoJson: restricao.geometry
                    });
                });
            }
        },

        tabelaHistoricoAgricolaHover(row) {
            let layerTerritorio = {
                style: getEstiloGeometria('historicoAgricola'),
                name: 'Histórico',
                geoJson: row.geometria
            };

            this.layersMaps = [...this.layersMaps, layerTerritorio];
        },
        tabelaHistoricoAgricolaLeaver() {
            this.layersMaps = this.layersMaps.filter(
                l => l.name !== this.$t('mensagens.territorio.labels.historico')
            );
        },
        async getCultura() {
            try {
                const { data } = await CulturaService.buscarCultura();
                this.territorio.informacaoAgricolaPY =
                    this.territorio?.informacaoAgricolaPY?.map(item => {
                        return {
                            ...item,
                            nome: data.find(
                                cultivo => cultivo.id === item.idCultura
                            )?.nomeTraduzido
                        };
                    });
            } catch (error) {}
        }
    }
};
</script>

<style lang="scss">
.visualizar-territorio {
    padding: 20px;
    height: 100%;
    width: 100%;
    display: flex;
}

header {
    grid-area: header;
    margin-bottom: 30px;

    h1 {
        line-height: 1;
    }
}

.dados {
    width: 400px;
    background-color: var(--white);

    padding: 16px;
    border-radius: 5px 0 0 5px;

    overflow: auto;

    .mb1 {
        margin-bottom: 15px;
        margin-top: 20px;
    }

    .mb2 {
        margin-bottom: 32px;
    }

    p {
        line-height: 1;
    }

    .el-collapse-item__content {
        padding-bottom: 0 !important;
    }
}

.mapa {
    grid-area: mapa;
    width: 100%;
    border-radius: 0 5px 5px 0;
    overflow: hidden;
}

.back {
    cursor: pointer;
    line-height: 2;
}

.titulo-collapse {
    font-size: 18px;
    font-weight: normal;
}

.container-dados-collapse {
    margin-top: 15px;
}

.container-nenhum-resultado-collapse {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    i {
        color: #a7a7a7;
        font-size: 30px;
    }
}

.arquivo-lista {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 12px;
}

.arquivo-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .grid-colums-cards {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;

        .arquivo-info-acao {
            display: flex;
            align-items: flex-end;
            justify-content: center;
        }
    }
}

.evidencia-declaracao-jurada-item {
    .evidencia-dj-row-1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;

        .arquivo-info {
            max-width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .arquivo-info-acao {
            flex-shrink: 0;
        }
    }

    .evidencia-dj-row-2 {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 3rem;
    }
}

.arquivo-icon {
    font-size: 20px;
}

.divisor-arquivo {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    margin: 12px 0 0 0;
}

#tabelas-collapse {
    font-size: 14px;
    color: var(--primary-font-color);

    tr:nth-child(odd) {
        background-color: var(--selected-background-color);
    }

    // Hover effect nas linhas da tabela de arquivos
    .el-table__row {
        transition: background-color 0.2s ease;

        &:hover {
            background-color: #f5f7fa !important;
            cursor: pointer;
        }
    }
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: var(--primary-font-color) !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td {
    border: none !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td
    > .cell
    > span {
    word-break: break-word;
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    border: none !important;
}

.text-align-right {
    text-align: right;
}

.item-list-row {
    display: grid;
    grid-template-columns: auto auto auto;
    width: 100%;
    column-gap: 10px;
}

.custom-divider {
    margin-bottom: 1px !important;
    margin-top: -12px !important;
}

// Estilos específicos para a seção de arquivos
.arquivo-info {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    .header-info {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .arquivo-icon {
        font-size: 16px;
    }

    .arquivo-information {
        font-weight: 500;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
    }
}

.arquivo-tamanho {
    font-size: 12px;
    color: #666;
    font-weight: 500;
}

.download-btn {
    transition: all 0.3s ease;

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
    }

    &:active {
        transform: scale(0.95);
    }
}

// Estilos para as tags de tipo de arquivo
.el-tag {
    font-size: 11px;
    font-weight: 600;
    border-radius: 12px;
    padding: 2px 8px;
}

// Estilos para seção de certificações
.certificacao-lista {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.certificacao-item {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 16px;
}

.certificacao-nome {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 12px;
    
    .header-info {
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.3s ease;
        
        strong {
            font-size: 14px;
            font-weight: 700;
            color: var(--primary-font-color);
        }
        
        .arquivo-icon {
            font-size: 20px;
            color: var(--primary);
            transition: color 0.3s ease;
        }
        
        &.sem-evidencia {
            .arquivo-icon {
                color: #f56c6c; // warning color
            }
        }
    }
    
    .certificacao-info {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 8px;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        background-color: #f8f9fa;
        border-left: 3px solid var(--primary);
        transition: all 0.3s ease;
        
        &.sem-evidencia {
            background-color: #fef0f0;
            border-left-color: #f56c6c;
            
            .certificacao-icon {
                color: #f56c6c;
            }
            
            .certificacao-nome-texto {
                color: #f56c6c;
            }
        }
        
        .certificacao-icon {
            font-size: 16px;
            color: var(--primary);
        }
        
        .certificacao-nome-texto {
            font-size: 13px;
            font-weight: 600;
            color: #333;
            display: flex;
            align-items: center;
            gap: 4px;
        }
    }
}

.evidencia-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 8px;
    .grid-colums-cards {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;

        .arquivo-info-acao {
            display: flex;
            align-items: flex-end;
            justify-content: center;
        }
    }
}
</style>
